import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "../index.css";

export const ListElement = ({
  listRef,
  children,
  scrollSnapping,
  showCarousel
}) => (
  <ul
    ref={listRef}
    className={classnames(styles.list, {
      [styles.scrollSnapping]: scrollSnapping
    })}
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    tabIndex={showCarousel ? 0 : undefined}
  >
    {children}
  </ul>
);

ListElement.propTypes = {
  listRef: PropTypes.object,
  children: PropTypes.node,
  scrollSnapping: PropTypes.bool,
  showCarousel: PropTypes.bool
};
